import React from "react";
import { Helmet } from "react-helmet";

const DisclosurePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 dark:from-gray-50 dark:via-gray-100 dark:to-gray-50">
      <Helmet>
        <title>Affiliate Disclosure | OpticPicker</title>
        <meta name="description" content="OpticPicker affiliate disclosure — we may earn commissions when you purchase through our retailer links." />
        <link rel="canonical" href="https://www.opticpicker.com/disclosure" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="bg-gray-800/60 dark:bg-white/80 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50 dark:border-gray-300">
          <h1 className="text-4xl font-bold text-white dark:text-gray-900 mb-6">
            Affiliate Disclosure
          </h1>

          <div className="prose prose-invert dark:prose-gray max-w-none">
            <p className="text-gray-300 dark:text-gray-700 mb-4">
              [YOUR DISCLOSURE TEXT HERE - Replace this placeholder with your
              actual disclosure]
            </p>

            <h2 className="text-2xl font-bold text-white dark:text-gray-900 mt-6 mb-3">
              What This Means for You
            </h2>
            <p className="text-gray-300 dark:text-gray-700 mb-4">
              [Add your explanation here]
            </p>

            <h2 className="text-2xl font-bold text-white dark:text-gray-900 mt-6 mb-3">
              Our Commitment
            </h2>
            <p className="text-gray-300 dark:text-gray-700 mb-4">
              [Add your commitment statement here]
            </p>

            <h2 className="text-2xl font-bold text-white dark:text-gray-900 mt-6 mb-3">
              Contact Us
            </h2>
            <p className="text-gray-300 dark:text-gray-700">
              If you have any questions about our affiliate relationships,
              please contact us at [your email].
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclosurePage;
